import { render, staticRenderFns } from "./BucketsTable.vue?vue&type=template&id=a296410e&scoped=true"
import script from "./BucketsTable.ts?vue&type=script&lang=ts&external"
export * from "./BucketsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./BucketsTable.vue?vue&type=style&index=0&id=a296410e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a296410e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a296410e')) {
      api.createRecord('a296410e', component.options)
    } else {
      api.reload('a296410e', component.options)
    }
    module.hot.accept("./BucketsTable.vue?vue&type=template&id=a296410e&scoped=true", function () {
      api.rerender('a296410e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/S3Connector/components/BucketsTable/BucketsTable.vue"
export default component.exports